import {v4 as uuid } from 'uuid';
import { getOriginRoot } from '../../../../commons/utils/constants';
import { detectClassesInCSS, ClientsCSSTargets } from '../../../../commons/utils/css';
import TranslationIds from '../../../../commons/translationIds';

import paramsMethods from './paramsMethods';

/*
 * kickstartPreviewMode skips API Calls..
 */
export async function kickstartPreviewMode () {
    const env = this.env;
    await this.getLocation();
    this.manageParams();
    await env.languageStore.getTranslations();
    env.appClientStore.notifyClientPage({
        action: 'kickstartComplete',
        data: {
            widget: this.widget,
        },
    });
    this.kickstarted = true;
    this.attachWidgetBG();
    this.observed.kickstarted = uuid();
    this.gotoCalendarApps();
}

/*
 * env.initApp() will be called first before kickstart happened.
 */

async function kickstart () {
    console.log('kickstart():');
    const env = this.env;
    if (!this.isPreview && this.widget?.customCssUrl) {
        this.attachCustomCSS(this.widget.customCssUrl);
    }

    this.gotoLoading();

    if (this.isPreview) {
        await this.kickstartPreviewMode();
        return;
    }

    await this.getLocation();
    this.manageParams();

    if (!this.directLink) {
        await env.languageStore.getTranslations();
    }
    
    await this.getOptins();

    console.log('kickstart() this.skip_schedule_selection :', this.skip_schedule_selection);
    if (!this.skip_schedule_selection) {
        await env.schedulesStore.getSchedules()
    }

    // has init errors
    if (hasInitErrors(env)) {
        return;
    }
    
    env.uiStatesStore.initFieldValues();
    env.appClientStore.notifyClientPage({
        action: 'kickstartComplete',
        data: {
            widget: this.widget,
        },
    });
    this.kickstarted = true;
    this.observed.kickstarted = uuid();

    if (this.shouldAutoSubscribe()) return;
    this.gotoSchedules();
}

export async function attachCustomCSS (customCss) {
    // this can be used to fine tune which classes are available that will override styles
    this.cssCustomClasses = await detectClassesInCSS(customCss, ClientsCSSTargets);
    // console.log('attachCustomCSS() this.cssTargetClasses: ', this.cssCustomClasses);
    const oldLink = document.getElementById('ecal-custom-css');
    if (oldLink) {
        document.head.removeChild(oldLink);
    }
    const self = this;
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', `${customCss}?t=${uuid()}`);
    link.setAttribute('id', 'ecal-custom-css');
    link.onload = (v) => {
        self.customCss = customCss;
        self.observed.customCss = uuid();
    }
    document.head.appendChild(link);
}

export function attachWidgetBG () { 
    if (!this.directLink) {
        return;
    }
    const widget = this.widget;
    let backgroundURL = widget?.background_image;
    if (!backgroundURL && !this.isPreview) {
        backgroundURL = `${getOriginRoot()}/assets/images/default-background.jpg`;
    }

    const root = document.getElementById('root');
    if (root) {
        root.style.position = 'absolute';
        root.style.top = '0px';
        root.style.left = '0px';
        root.style.bottom = '0px';
        root.style.right = '0px';
        root.style.background = `transparent url(${backgroundURL}) no-repeat`;
        root.style['background-size'] = 'cover';
    }
    // document.body.style.background = `transparent url(${backgroundURL}) no-repeat`;
    // document.body.style['background-size'] = 'cover';
}

/*
 * even on skip_schedule_selection ( which means the no schedules is) 
 */
export function hasInitErrors (env) {
    const appStore = env.appStore;
    const schedulesStore = env.schedulesStore;

    if (schedulesStore.schedulesError) {
        env.errorsStore.dispatch({
            title: appStore.translate(TranslationIds.COMPONENT_WHOA),
            message: appStore.translate(TranslationIds.SUCCESS_PAGE_COULD_NOT_FIND),
        });
        env.appStore.gotoErrors();
        return true;
    }
    return false;
}

export function shouldAutoSubscribe () {
    const schedulesStore = this.env.schedulesStore;
    const statesStore = this.env.uiStatesStore;
    let autoSubscribe = this.widget.auto_subscribe;
    console.log('shouldAutoSubscribe() autoSubscriber(): ', this.params);
    if (!autoSubscribe && this.params.autoSubscribe !== undefined) {

        if (typeof this.params.autoSubscribe === 'boolean') {
            autoSubscribe = this.params.autoSubscribe;
        } else if (typeof this.params.autoSubscribe.toLowerCase === 'function') {
            autoSubscribe = JSON.parse(this.params.autoSubscribe.toLowerCase());
        }
    }


    if (autoSubscribe ||
        (schedulesStore.schedules?.length === 1 && !schedulesStore.byCategories ) || 
        this.skip_schedule_selection
    ) {
        schedulesStore.selectAllSchedules();
        this.autoSubscribe = true;
        statesStore.captureFields();
        this.gotoCalendarApps();
        return true;
    }

    return false;
}

export const kickstarters = {
    ...paramsMethods,
    attachCustomCSS,
    attachWidgetBG,
    shouldAutoSubscribe,
    kickstartPreviewMode,
};

export default kickstart;
